import { RootState } from 'app/store';
import { createSelector } from 'reselect';
import clientsAdapter from './clients.adapter';
import { ClientState } from './clients.slice';

export const { selectAll: selectUserClient } = clientsAdapter.getSelectors((state: RootState) => state.clients || {});

export const clientsSelector = (state: { clients: ClientState }) => state.clients || {};

export const isLoadingSelector = createSelector(clientsSelector, client => client.isLoading);
export const clientListStateSelector = createSelector(clientsSelector, client => client.clientListState);
export const isClientLoyaltyLoadingSelector = createSelector(clientsSelector, client => client.isClientLoyaltyLoading);
export const isClientCouponsLoadingSelector = createSelector(
  clientsSelector,
  client => client.isClientActiveCouponsLoading,
);
export const selectClientsError = createSelector(clientsSelector, client => client.hasError);
export const selectNotFoundClientId = createSelector(clientsSelector, client => client.notFoundClientId);
export const selectSelectedClient = createSelector(clientsSelector, client => client.selectedClient);
export const selectCreditPointsModal = createSelector(clientsSelector, client => client.creditPointsModal);
export const selectUserDialogOpened = createSelector(clientsSelector, client => client.userDialogOpened);
export const selectEditUserDialogOpened = createSelector(clientsSelector, client => client.editUserDialogOpened);
export const selectClientsMetadata = createSelector(clientsSelector, client => client.metadata);
export const selectHiddenPartialClients = createSelector(clientsSelector, client => client.hiddenPartialClients ?? 0);
export const selectColumnPreferences = createSelector(clientsSelector, clients => clients.columnPreferences);

export const selectColumnsDialogOpened = createSelector(clientsSelector, clients => clients.columnsDialogOpened);

export const selectAddColumnDrawerOpened = createSelector(clientsSelector, clients => clients.addColumnDrawerOpened);

export const selectClientsSort = createSelector(clientsSelector, client => client.sort);
export const selectClientsFilters = createSelector(clientsSelector, client => client.filters);
export const selectClientsPagination = createSelector(clientsSelector, client => client.pagination);
export const clientsHasAppliedFiltersSelector = createSelector(selectClientsFilters, filters => {
  return Boolean(
    filters.searchText ||
      filters.selectedStore ||
      filters.acquiredFrom.length ||
      filters.clientsType.length ||
      filters.segmentRefs.length ||
      filters.crmFilter ||
      filters.record ||
      filters.activityPeriod,
  );
});
/** Filters folded into the filters panel; search and store stay in sight, so they are not counted. */
export const countPanelFilters = (filters: ClientState['filters']): number =>
  [
    filters.acquiredFrom.length,
    filters.clientsType.length,
    filters.segmentRefs.length,
    filters.crmFilter,
    filters.record,
    filters.activityPeriod,
  ].filter(Boolean).length;
export const clientsPanelFilterCountSelector = createSelector(selectClientsFilters, countPanelFilters);
export const selectClientsHasLoadedFiltersSortPagination = createSelector(
  clientsSelector,
  client => client.hasLoadedFiltersSortPagination,
);
export const clientCouponsSelector = createSelector(clientsSelector, client => client.currentClientCoupons);
export const redeemOfferDialogSelector = createSelector(clientsSelector, client => client.redeemOfferDialog);
export const redeemCouponDialogSelector = createSelector(clientsSelector, client => client.redeemCouponDialog);
export const clientTransactionsSelector = createSelector(clientsSelector, client => client.currentClientTransactions);
export const clientTopProductsSelector = createSelector(clientsSelector, client => client.currentClientTopProducts);
export const formQuestionColumnsSelector = createSelector(clientsSelector, client => client.formQuestionColumns);
export const clientFormResponsesSelector = createSelector(clientsSelector, client => client.currentClientFormResponses);
